var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-heigt py-10",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('details-card',{attrs:{"guest":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }